import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./state/AuthContext";
import { RequireAuth } from "./components/RequireAuth";
import { AppShell } from "./components/AppShell";
import { LoginPage } from "./pages/LoginPage";
import { ModulePage } from "./pages/ModulePage";
import { HelpDeskPage } from "./pages/HelpDeskPage";
import { ReleaseNotesPage } from "./pages/ReleaseNotesPage";
import { TimekeepingPage } from "./pages/TimekeepingPage";
import { PayrollPage } from "./pages/PayrollPage";
import { ProfilePage } from "./pages/ProfilePage";
import { LeavePage } from "./pages/LeavePage";
import { ExpensesPage } from "./pages/ExpensesPage";
import { CompanyAdminPage } from "./pages/CompanyAdminPage";
import { BenefitsPage } from "./pages/BenefitsPage";
import { LaborDistributionPage } from "./pages/LaborDistributionPage";
import { DcaaCompliancePage } from "./pages/DcaaCompliancePage";
import { ChargeCodesPage } from "./pages/ChargeCodesPage";
import { OrgHierarchyPage } from "./pages/OrgHierarchyPage";
import { ContractsPage } from "./pages/ContractsPage";
import { PortfolioPage } from "./pages/PortfolioPage";
import { HomeRedirect, WorkbenchHome } from "./pages/WorkbenchHome";
import { MODULES } from "./lib/modules";

const SPECIAL = new Set([
  "helpdesk",
  "timekeeping",
  "payroll",
  "profile",
  "leave",
  "benefits",
  "expenses",
  "company-admin",
  "labor",
  "dcaa",
  "charge-codes",
  "org-hierarchy",
  "contracts",
  "portfolio",
]);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route path="/app" element={<AppShell />}>
              <Route index element={<HomeRedirect />} />
              <Route path="workbench" element={<WorkbenchHome />} />
              <Route path="helpdesk" element={<HelpDeskPage />} />
              <Route path="release-notes" element={<ReleaseNotesPage />} />
              <Route path="timekeeping" element={<TimekeepingPage />} />
              <Route path="labor" element={<LaborDistributionPage />} />
              <Route path="dcaa" element={<DcaaCompliancePage />} />
              <Route path="charge-codes" element={<ChargeCodesPage />} />
              <Route path="org-hierarchy" element={<OrgHierarchyPage />} />
              <Route path="contracts" element={<ContractsPage />} />
              <Route path="portfolio" element={<PortfolioPage />} />
              <Route path="payroll" element={<PayrollPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="leave" element={<LeavePage />} />
              <Route path="benefits" element={<BenefitsPage />} />
              <Route path="expenses" element={<ExpensesPage />} />
              <Route path="company-admin" element={<CompanyAdminPage />} />
              {MODULES.filter((m) => !SPECIAL.has(m.id)).map((m) => (
                <Route key={m.id} path={m.id} element={<ModulePage moduleId={m.id} />} />
              ))}
            </Route>
          </Route>
          <Route path="/" element={<Navigate to="/app" replace />} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
